import * as React from 'react'
import { SafetyCertificateOutlined, CloseCircleTwoTone, CheckCircleTwoTone } from '@ant-design/icons'
import { Button, List, Modal, PageHeader, Row, Table } from 'antd'
import { Menu, Space, Typography, Tooltip, Spin } from 'antd'
import moment from 'moment'
import { DataNode } from 'antd/lib/tree'

import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { AccessoCcModel, AccessoContiCorrentiModel, AccessoContoCorrenteModel, CatDataNode, ContiCorrentiModel, ContoCorrenteModel } from '../../models/ConfigurazioneModels'
import { ModalCategoria, OperationType } from './ModalCategoria'
import { EsempioCategorie } from './EsempioCategorie'
import Operation from 'antd/lib/transfer/operation'
import Search from 'antd/lib/input/Search'
import { TTAvatar } from '../shared/TTAvatar'
import Column from 'antd/lib/table/Column'
import { IYapilyService } from '../../services/YapilyService'
const { Text } = Typography

class PageAccessoCcState extends AccessoContiCorrentiModel {
    //ModalVisible: boolean = false
    //SelectedNode: DataNode
    //OperationModal: OperationType
}

export class PageAccessoCc extends React.Component<any, PageAccessoCcState> {

    service: IConfigurazioneService
    yapilyService: IYapilyService

    noProvider: boolean

    constructor(props) {
        super(props)
        this.state = new PageAccessoCcState()
        this.service = container.get(SERVICE_IDENTIFIER.CONFIGURAZIONE_SERVICE)
        this.yapilyService = container.get(SERVICE_IDENTIFIER.YAPILY_SERVICE)
    }

    componentDidMount() {
        this.loadPage()
    }

    loadPage = async () => {
        let resp = await this.service.GetAccessoContiCorrenti()
        this.noProvider = false
        if (resp.IsValid == true) {
            if (resp.Code == "NO_PROVIDER")
                this.noProvider = true
            else
                this.setState(resp)
        }
    }

    onConcedi = (data: AccessoContoCorrenteModel) => {
        Modal.confirm({
            title: "Consenso",
            content: "Stai per iniziare le procedura di consenso, che ci permetterà di importare automaticamente i movimenti del tuo conto corrente. Se non proseguirai, non sarà possibile importare automaticamente i movimenti dal tuo conto corrente. Vuoi proseguire con la procedura di consenso?",
            onOk: async () => {
                window.location.href = data.IsEmbeddedFlow != null && !data.IsEmbeddedFlow ?
                    "/Configurazione/Consensi/" + data.Id : "/Configurazione/ConsensiEmbedded/" + data.Id
            }
        })
    }

    onRevoca = (data: AccessoContoCorrenteModel) => {
        let list: AccessoContoCorrenteModel[] = this.state.ContiCorrenti.filter(c => c.ConsentToken == data.ConsentToken)
        if (list == null && list.length == 0) return
        let cc = ""
        for (var i = 0; i < list.length; i++) {
            cc += "," + list[i].NomeConto
        }

        let content = "Questo consenso permette l’accesso automatico ai tuoi conti correnti: " + cc.substring(1) + ". " +
            "Se revochi il consenso non potremo più leggere automaticamente i movimenti da questi conti correnti.Sei sicuro di voler proseguire ?"
        Modal.confirm({
            title: "Consenso",
            content: content,
            onOk: async () => {
                let res = await this.yapilyService.Revoca(data.ConsentToken)
                if (res.IsValid == true)
                    await this.loadPage()
            }
        })
    }

    renderDate = (data: Date) => {
        if (data == null) return ""
        return moment(data).format('LL')
    }

    renderConsenso = (data: boolean) => {
        if (data) return (<CheckCircleTwoTone twoToneColor="green" />)
        return (<CloseCircleTwoTone twoToneColor="red" />)
    }

    getBotton = (record: AccessoContoCorrenteModel) => {
        let errIbanEmpty = "Devi configurare l'IBAN"
        let errBancaEmpty = "Non siamo riusciti a recuperare il nome della banca dal tuo IBAN. Ti chiediamo cortesemente di contattare il supporto."
        //"Non è presente la Banca di riferimento al tuo IBAN. Contatta il supporto"
        if (record.Consenso) {
            if (record.Iban == null || record.Iban == "")
                return (
                    <Tooltip title={errIbanEmpty} >
                        <Button type="primary" disabled={true} key="revoca-consenso" icon={<SafetyCertificateOutlined />} size="small" >&nbsp;Revoca Consenso</Button>
                    </Tooltip>
                )
            if (record.Banca == null || record.Banca == "")
                return <Tooltip title={errBancaEmpty}>
                    <Button type="primary" disabled={true} key="revoca-consenso" icon={<SafetyCertificateOutlined />} size="small" >&nbsp;Revoca Consenso</Button>
                </Tooltip>
            return (
                <Button type="primary" key="revoca-consenso" icon={<SafetyCertificateOutlined />} size="small" onClick={() => this.onRevoca(record)} >&nbsp;Revoca Consenso</Button>
            )
        }

        if (record.Iban == null || record.Iban == "")
            return (
                <Tooltip title={errIbanEmpty}>
                    <Button type="primary" disabled={true} key="concedi-consenso" icon={<SafetyCertificateOutlined />} size="small" >&nbsp;Dai Consenso</Button>
                </Tooltip>
            )
        if (record.Banca == null || record.Banca == "")
            return (<Tooltip title={errBancaEmpty}>
                <Button type="primary" disabled={true} key="concedi-consenso" icon={<SafetyCertificateOutlined />} size="small"  >&nbsp;Dai Consenso</Button>
            </Tooltip>
            )

        return (
            <Button type="primary" key="concedi-consenso" icon={<SafetyCertificateOutlined />} size="small" onClick={() => this.onConcedi(record)} >&nbsp;Dai Consenso</Button>
        )
    }

    customRender = () => {
        if (this.noProvider)
            return (<p>Provider non configurato</p>)
        else
            return (<Table
                dataSource={this.state.ContiCorrenti}
                rowKey={it => it.Id}>
                <Column title="Nome conto" dataIndex="NomeConto" />
                <Column title="Banca" dataIndex="Banca" />
                <Column title="IBAN" dataIndex="Iban" />
                <Column title="Consenso" dataIndex="Consenso" render={(value: boolean) => this.renderConsenso(value)} />
                <Column title="Data consenso" dataIndex="DataConsenso" render={(value: Date) => this.renderDate(value)} />
                <Column title="Data scadenza" dataIndex="DataScadenza" render={(value: Date) => this.renderDate(value)} />
                <Column title="" dataIndex="Id" render={(_, record: AccessoContoCorrenteModel) =>
                    this.getBotton(record)
                } />
            </Table>)

    }

    render() {
        return (
            <PageHeader title="Accesso CC" >
                {this.customRender()}
            </PageHeader>
        )
    }
}